import { render } from "./plebs_and_pillagers.html?vue&type=template&id=3d655943&external"
import script from "./plebs_and_pillagers.js?vue&type=script&lang=js&external"
export * from "./plebs_and_pillagers.js?vue&type=script&lang=js&external"

import "./plebs_and_pillagers.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__